const groupPrefix = createApiRoute(ApiModule.PRODUCTION_PLANNING, ApiModule.EMPLOYEE)

export type TPromarkLabelType = 'meal' | 'bag'

export interface IPromarkResendResult {
	delivery_date: string
	label_type: TPromarkLabelType
	jobs_dispatched: number
}

export const apiPromarkLabels = {
	resendPromarkLabels: async (date: Date, labelType: TPromarkLabelType): Promise<IPromarkResendResult> => {
		const { data } = await apiCommon<IPromarkResendResult>(`${groupPrefix}/promark-labels/resend`, {
			method: 'POST',
			body: {
				date: dateToFilterFormat(date),
				label_type: labelType,
			},
		})

		return data
	},
}
